import { render } from "./ReportTemplateEdit.vue?vue&type=template&id=3dbbe0d6&scoped=true"
import script from "./ReportTemplateEdit.vue?vue&type=script&lang=js"
export * from "./ReportTemplateEdit.vue?vue&type=script&lang=js"

import "./ReportTemplateEdit.vue?vue&type=style&index=0&id=3dbbe0d6&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbbe0d6"]])

export default __exports__